export default __webpack_public_path__ + "static/media/Free_Balance_Cover.d8035a5f.jpg";